import { render, staticRenderFns } from "./JoiningApplicationSubscriptions.vue?vue&type=template&id=197cc8a4&"
import script from "./JoiningApplicationSubscriptions.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports